import React from 'react';
import { Select } from 'antd';

/**
 * منوی انتخاب همه / حذف همه
 */
export function bulkSelectPopupRender(menu, { allValues = [], onChange }) {
  const stop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleSelectAll = () => {
    onChange?.([...allValues]);
  };

  const handleClearAll = () => {
    onChange?.([]);
  };

  return (
    <>
      <div
        style={{ padding: '6px 8px', borderBottom: '1px solid #f0f0f0' }}
        onMouseDown={stop}
      >
        <span
          role="button"
          tabIndex={0}
          onMouseDown={stop}
          onClick={(e) => {
            stop(e);
            handleSelectAll();
          }}
          style={{
            color: '#1677ff',
            cursor: 'pointer',
            fontSize: 13,
            fontFamily: 'CustomFont',
            marginLeft: 12,
          }}
        >
          انتخاب همه
        </span>
        <span
          role="button"
          tabIndex={0}
          onMouseDown={stop}
          onClick={(e) => {
            stop(e);
            handleClearAll();
          }}
          style={{
            color: '#1677ff',
            cursor: 'pointer',
            fontSize: 13,
            fontFamily: 'CustomFont',
          }}
        >
          حذف همه
        </span>
      </div>
      {menu}
    </>
  );
}

/**
 * Select چندانتخابی با انتخاب همه / حذف همه — سازگار با Form.Item (value/onChange از Form تزریق می‌شود)
 */
export function BulkSelect({
  allValues = [],
  mode = 'multiple',
  value,
  onChange,
  children,
  popupRender: userPopupRender,
  dropdownRender: userDropdownRender,
  ...rest
}) {
  if (mode !== 'multiple' || !allValues.length) {
    return (
      <Select mode={mode} value={value} onChange={onChange} {...rest}>
        {children}
      </Select>
    );
  }

  const mergePopup = (menu) => {
    const bulkMenu = bulkSelectPopupRender(menu, { allValues, onChange });
    const legacyRender = userPopupRender || userDropdownRender;
    return legacyRender ? legacyRender(bulkMenu) : bulkMenu;
  };

  return (
    <Select
      mode={mode}
      value={value}
      onChange={onChange}
      popupRender={mergePopup}
      {...rest}
    >
      {children}
    </Select>
  );
}

/** @deprecated از BulkSelect استفاده کنید */
export function withBulkSelect(selectProps, allValues = []) {
  return selectProps || {};
}

export function bulkSelectDropdownRender(menu, options) {
  return bulkSelectPopupRender(menu, options);
}
